import {Observable, throwError as observableThrowError} from 'rxjs';

import {catchError} from 'rxjs/operators';
import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {AuthenticationService} from './authentication.service';
import {environment} from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TicketService {

  private headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': 'Bearer ' + this.authenticationService.token
  });

  constructor(private http: HttpClient,
              private authenticationService: AuthenticationService) {
  }

  getTicketSubjects(): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'ticket-subjects/', {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error.error || 'Server error')));
  }

  addTicket(ticket: any): Observable<any> {
    return this.http.post(environment.apiBaseUrl + 'ticket/',
      JSON.stringify(ticket), {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error.error || 'Server error')));
  }

  deleteTicket(ticketID): Observable<any> {
    return this.http.delete(environment.apiBaseUrl + 'ticket/' + ticketID, {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error.error || 'Server error')));
  }

  getTickets(page): Observable<any> {
    return this.http.get(environment.apiBaseUrl + 'ticket-firm/' + page, {headers: this.headers}).pipe(
      // ...errors if any
      catchError((error: any) => observableThrowError(error || 'Server error')));
  }

}
